module.exports = __webpack_public_path__ + "img/john_wick.38addcd6.jpg";